/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Alert, Button, Drawer, Icon, Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import MapPropsContext from "../MapPropsContext";
import { getListByUidArray } from "../../../api";
import usePortal from "react-useportal";
import { getLastDomByClassName } from "../../../utils";
import { StyledButton, StyledDisabledButton } from "../../../styled-components/Button";

const WidgetTable = ({
  getTitle,
  columns,
  fetchUrl,
  horizontalScroll,
  verticalScroll,
  isUidSearch = false,
  disabled,
  visible,
  setVisible,
  widgetTabIndex,
}) => {
  const { filteredPointsResponseList, clickedPointIconObjects } = useContext(MapPropsContext);

  const [detailObjects, setDetailObjects] = useState();
  // const [visible, setVisible] = useState(false);
  const [error, setError] = useState();

  const [isDownloading, setIsDownloading] = useState(false);

  // 컬럼 정렬 기준값을 담아둘 상탯값을 정의하고, 이를 각 컬럼의 sortOrder에 반영합니다.
  const [sortedInfo, setSortedInfo] = useState({});
  const newColumns = useMemo(() => {
    return columns.map((column) => {
      const { dataIndex } = column;
      const { columnKey, order } = sortedInfo || {};
      const sortOrder = columnKey === dataIndex && order;
      return {
        ...column,
        sortOrder,
      };
    });
  }, [columns, sortedInfo]);

  // 테이블의 변경정보를 관련 상탯값에 반영합니다.
  const onChangeTable = useCallback((pagination, filters, sorter) => {
    setSortedInfo(sorter);
  }, []);

  // 다수 Points 레이어내 무선국 정보를 하나의 Array로 통합합니다.
  const integratedLayer = filteredPointsResponseList.flat();

  const uidArray = useMemo(() => {
    if (isUidSearch && clickedPointIconObjects[0]) {
      // return [clickedPointIconObjects[0]['uid']];
      // 아이콘이 여러 개 중복돼서 클릭한 화면의 목록보기가 1개만 나옴 => 클릭된 무선국들 모두 나오도록 조치했습니다.
      return clickedPointIconObjects.map(({ uid }) => uid);
    } else {
      return integratedLayer.map(({ uid }) => uid);
    }
  }, [filteredPointsResponseList, clickedPointIconObjects]);

  useEffect(() => {
    if (!visible) {
      setDetailObjects(undefined);
      setSortedInfo(null);
    } else if (visible && fetchUrl) {
      setError(null);
      const jungon = clickedPointIconObjects.map(({ jungon }) => jungon);
      const isJungon = clickedPointIconObjects.length === 1 && jungon.toString() === "Y" ? "Y" : "N";
      getListByUidArray({
        relUrl: isJungon === "Y" ? `${fetchUrl}&isJungon=Y` : fetchUrl,
        uidArray,
      })
        .then(({ data }) => {
          setDetailObjects(data.data); // data(response)에서 data객체 참조
        })
        .catch((e) => {
          setError(e);
        });
    }
  }, [visible, uidArray, fetchUrl]);

  useEffect(() => {
    // 딜레이를 주어, 보다 자연스럽게 Drawer창을 끕니다.
    if (clickedPointIconObjects && clickedPointIconObjects.length > 0 && visible) {
      setTimeout(() => {
        setVisible(false);
      }, 200);
    }
  }, [clickedPointIconObjects]);

  const downloadXlsx = useCallback(() => {
    setIsDownloading(true);
    getListByUidArray({ relUrl: fetchUrl, uidArray, isExcelDownload: true })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setIsDownloading(false);
      });
  }, [uidArray, fetchUrl]);

  const { Portal } = usePortal({
    bindTo: getLastDomByClassName("toolbar-show-list"),
  });

  const showListButtonRef = useRef();

  return (
    <>
      <Portal>
        <StyledButton
          isActive={visible}
          disabled={false} // 수정 필요
          onClick={() => setVisible(true)}
          tabIndex={widgetTabIndex}
          ref={showListButtonRef}
        >
          목록 보기
        </StyledButton>
      </Portal>

      <Drawer
        title={getTitle(detailObjects || integratedLayer)}
        placement={"bottom"}
        height={300 + 200}
        closable={false}
        onClose={() => setVisible(false)}
        bodyStyle={{ padding: 12 }}
        visible={visible}
      >
        {!fetchUrl && <Alert type="error" message="fetchUrl 미등록" />}
        {fetchUrl && (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginBottom: "8px",
              }}
            >
              {!fetchUrl || isDownloading || !detailObjects ? (
                <StyledDisabledButton style={{ marginRight: 8 }}>
                  {isDownloading && <Icon type="loading" />}
                  {!isDownloading && <FontAwesomeIcon icon={faFileExcel} />}
                  <span style={{ marginLeft: 8 }}>엑셀 내보내기</span>
                </StyledDisabledButton>
              ) : (
                <StyledButton
                  onClick={downloadXlsx}
                  style={{ marginRight: 8 }}
                  isActive
                  // tabIndex={TI_LIST_CLOSE_BUTTON - 1}
                >
                  {isDownloading && <Icon type="loading" />}
                  {!isDownloading && <FontAwesomeIcon icon={faFileExcel} />}
                  <span style={{ marginLeft: 8 }}>엑셀 내보내기</span>
                </StyledButton>
              )}

              <StyledButton
                onClick={() => {
                  showListButtonRef.current.focus();
                  setVisible(false);
                }}
                // tabIndex={TI_LIST_CLOSE_BUTTON}
              >
                닫기
              </StyledButton>
            </div>
            <div style={STYLE_CONTENT}>
              {error && <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"} />}
              {!error && (
                <Table
                  dataSource={
                    detailObjects &&
                    detailObjects.map((row, index) => ({
                      index: index + 1,
                      ...row,
                    }))
                  }
                  columns={newColumns}
                  onChange={onChangeTable}
                  size={"small"}
                  rowKey={"index"}
                  bordered={true}
                  loading={!detailObjects && !error}
                  ellipsis={true}
                  scroll={
                    {
                      // x: horizontalScroll || 1200,
                      // y: verticalScroll || 300,
                    }
                  }
                  tableLayout={"fixed"}
                  pagination={{
                    defaultPageSize: 7,
                    showSizeChanger: true,
                    pageSizeOptions: ["20", "50", "100"],
                  }}
                />
              )}
            </div>
          </>
        )}
      </Drawer>
    </>
  );
};

const STYLE_CONTENT = {
  height: "100%",
  marginBottom: "30px",
};

const STYLE_SUBMIT = {
  // position: "absolute",
  // top: 2,
  // right: 2,
  // padding: "10px 12px",
};

export default WidgetTable;
